/**
 * The six instruments, in header order. `key` is the app's internal id (App.js state),
 * `slug` is the URL path segment (/upright-bass), `label` is the Title Case display name.
 * `title` and `description` are the page's <title> and meta description: App.js sets them
 * on instrument change, and scripts/generate-instrument-pages.mjs bakes them into the
 * static /<slug> HTML that crawlers see.
 */
export const INSTRUMENTS = [
  {
    key: 'guitar', label: 'Guitar', slug: 'guitar',
    title: 'Guitar Scales, Modes & Arpeggios — Interactive Fretboard | ScaleBase',
    description: 'See every guitar scale, mode, pentatonic and arpeggio across the whole neck in any key. Interactive fretboard with CAGED shapes, note names and intervals.',
  },
  {
    key: 'mandolin', label: 'Mandolin', slug: 'mandolin',
    title: 'Mandolin Scales, Modes & Arpeggios — Interactive Fretboard | ScaleBase',
    description: 'Map mandolin scales, modes, pentatonics and arpeggios across the fretboard in any key. Free interactive chart for G D A E tuning.',
  },
  {
    key: 'banjo', label: 'Banjo', slug: 'banjo',
    title: 'Banjo Scales & Chords — Interactive Fretboard | ScaleBase',
    description: 'Banjo scales, modes, arpeggios and F, D and barre chord shapes in Open G tuning, shown on an interactive fretboard in any key.',
  },
  {
    key: 'dobro', label: 'Dobro', slug: 'dobro',
    title: 'Dobro Scales & Chords — Interactive Fretboard | ScaleBase',
    description: 'Dobro and resonator guitar scales, modes and chords in Open G tuning, mapped across the neck in any key on an interactive fretboard.',
  },
  {
    key: 'uprightBass', label: 'Upright Bass', slug: 'upright-bass',
    title: 'Upright Bass Scales & Arpeggios — Interactive Fingerboard | ScaleBase',
    description: 'Upright bass scales, modes, arpeggios and root-and-fifth patterns on an interactive fingerboard, with chord changes for bluegrass and jazz.',
  },
  {
    key: 'fiddle', label: 'Fiddle', slug: 'fiddle',
    title: 'Fiddle & Violin Scales, Double Stops — Interactive Fingerboard | ScaleBase',
    description: 'Fiddle and violin scales, modes, arpeggios and double stops on an interactive fingerboard, with finger positions, tapes and half steps.',
  },
];

export const SLUG_TO_INSTRUMENT = Object.fromEntries(INSTRUMENTS.map((i) => [i.slug, i.key]));
export const INSTRUMENT_TO_SLUG = Object.fromEntries(INSTRUMENTS.map((i) => [i.key, i.slug]));
export const VALID_INSTRUMENTS = INSTRUMENTS.map((i) => i.key);
